import { Injectable } from '@angular/core';
import {
  RutValidationResponse,
} from '../../models/http/RutValidation.interface';
import { UserInformation } from '../../models/UserInformation.interface';
import { mapper } from '../../utils/mappers';

@Injectable({
  providedIn: 'root',
})
export class StoreService {
  private _token!: string;
  private _userInfo!: UserInformation | null;

  constructor() {}

  get token() {
    return this._token;
  }

  get userInfo() {
    return this._userInfo;
  }

  public cleanUserInfo() {
    this._userInfo = null;
  }

  setStoreInfo(info: RutValidationResponse) {
    localStorage.setItem('bci-session-token', info.accessToken);
    this._token = info.accessToken;
    this._userInfo = mapper.userInfo(info);
  }
}
